import React, { useEffect, useState } from "react";
import ComparisonList from "./comparisonList";
import moment from "moment-timezone";

const ClaimDetails = ({
  imagesData,
  setImagePopup,
  openReasonPopup,
  handleFeedback,
  setOpenReasonPopup,
  data,
  handleUpdateFeedback,
  setQuestions,
  allImages,
  questions,
  setComponentType,
  componentType,
  feedbackData,
  setComponentFeedback,
  componentFeedback,
  setCheckFeedback,
  checkFeedback
}) => {
  const [values, setValues] = useState([]);
  const [processingValue, setProcessingValue] = useState([]);
  const [notification, setNofifcation] = useState([]);
  const [user, setUser] = useState([]);
  const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    if (data) {
      if (componentType === "TIRE") {
        setValues([
          {
            name: "Contract Number:",
            value: data?.contractNumber || "NA"
          },
          {
            name: "VIN:",
            value: data?.vin || "NA"
          },
          {
            name: "Tire Curb Allowed:",
            value:
              data?.tireContractCoverage?.tireCurbAllowed === "y"
                ? "Yes"
                : data?.tireContractCoverage?.tireCurbAllowed === "n"
                  ? "No"
                  : "-"
          },
          {
            name: "RO Number:",
            value: data?.roNumber
          },
          {
            name: "Tire Defect Allowed:",
            value:
              data?.tireContractCoverage?.tireDefectAllowed === "y"
                ? "Yes"
                : data?.tireContractCoverage?.tireDefectAllowed === "n"
                  ? "No"
                  : "-"
          },
          {
            name: "Claim Odometer:",
            value: data?.claimOdometer
          },
          {
            name: "Tire Repair First:",
            value:
              data?.tireContractCoverage?.tireRepairFirst === "y"
                ? "Yes"
                : data?.tireContractCoverage?.tireRepairFirst === "n"
                  ? "No"
                  : "-"
          },
          {
            name: "IsNis Claim:",
            value:
              data?.isNisClaim === "y"
                ? "Yes"
                : data?.isNisClaim === "n"
                  ? "No"
                  : "-"
          },
          {
            name: "Tire Replacement Only:",
            value:
              data?.tireContractCoverage?.tireReplacemenOnly === "y"
                ? "Yes"
                : data?.tireContractCoverage?.tireReplacemenOnly === "n"
                  ? "No"
                  : "-"
          }
        ]);
      } else {
        setValues([
          {
            name: "Contract Number:",
            value: data?.contractNumber || "NA"
          },
          {
            name: "VIN:",
            value: data?.vin || "NA"
          },
          {
            name: "Wheel Curb Allowed:",
            value:
              data?.wheelContractCoverage?.wheelCurbAllowed === "y"
                ? "Yes"
                : data?.wheelContractCoverage?.wheelCurbAllowed === "n"
                  ? "No"
                  : "-"
          },
          {
            name: "RO Number:",
            value: data?.roNumber
          },
          {
            name: "Wheel Defect Allowed:",
            value:
              data?.wheelContractCoverage?.wheelDefectAllowed === "y"
                ? "Yes"
                : data?.wheelContractCoverage?.wheelDefectAllowed === "n"
                  ? "No"
                  : "-"
          },
          {
            name: "Claim Odometer:",
            value: data?.claimOdometer
          },
          {
            name: "Wheel Repair First:",
            value:
              data?.wheelContractCoverage?.wheelRepairFirst === "y"
                ? "Yes"
                : data?.wheelContractCoverage?.wheelRepairFirst === "n"
                  ? "No"
                  : "-"
          },
          {
            name: "IsNis Claim:",
            value:
              data?.isNisClaim === "y"
                ? "Yes"
                : data?.isNisClaim === "n"
                  ? "No"
                  : "-"
          },
          {
            name: "Wheel Replacement Only:",
            value:
              data?.wheelContractCoverage?.wheelReplacementOnly === "y"
                ? "Yes"
                : data?.wheelContractCoverage?.wheelReplacementOnly === "n"
                  ? "No"
                  : "-"
          }
        ]);
      }
    }
    const diffInSeconds = (
      (data.processingEndTime - data.processingStartTime) /
      1000
    ).toFixed(2);
    setProcessingValue([
      {
        name: "Claim Submitted:",
        value: moment
          .tz(data.createdDateTime, "America/New_York")
          .tz(userTZ)
          .format("D MMMM YYYY [at] h:mm:ss A")
      },
      {
        name: "Claim sent for Processing:",
        value: moment(data?.eventPublishedTime).format(
          "D MMMM YYYY [at] h:mm:ss A"
        )
      },

      {
        name: "Claim Last Updated:",
        value: data?.modifiedDateTime
          ? moment
              .tz(data.modifiedDateTime, "America/New_York")
              .tz(userTZ)
              .format("D MMMM YYYY [at] h:mm:ss A")
          : "-"
      },
      {
        name: "Claim Processing completed:",
        value: data?.processingEndTime
          ? moment(data?.processingEndTime).format("D MMMM YYYY [at] h:mm:ss A")
          : "-"
      },
      {
        name: "Time Taken to Process the Claim:",
        value: `${diffInSeconds} Seconds`
      },
      {
        name: `Claim Processed Within Expected Time (${data?.repairFirstCheck?.expectedCompletionSeconds || 0}s)?:`,
        value: data.processedWithinSLA ? "Yes" : "No"
      },
      {
        name: "Claim Submitted Within Working Hours?:",
        value: data.isEventPublishedInWorkingHours
          ? "Yes"
          : data.isEventPublishedInWorkingHours === false
            ? "No"
            : "-"
      },
      {
        name: "STP / ECE Queue?:",
        value: data?.isEceQueue ? "ECE" : "STP"
      }
    ]);
    setNofifcation([
      {
        name: "Email Request Triggerd to System:",
        label: "(Delivery Not Confirmed)",
        value: data.ciaEventSent ? "Yes" : "No"
      },
      {
        name: "Email Sent From:",
        value: data?.notificationDetail?.eceQueue?.fromEmail || "-"
      },
      {
        name: "Email Sent To (Recepients):",
        value: data?.notificationDetail?.eceQueue?.toEmails?.join(", ")
      },
      {
        name: "BCC:",
        value: data?.notificationDetail?.eceQueue?.bcc?.join(", ")
      },
      {
        name: "CC:",
        value: data?.notificationDetail?.eceQueue?.cc?.join(", ")
      }
    ]);
    setUser([
      {
        name: "Login User ID (System Refrence):",
        value: data?.notificationDetail?.userNotification?.loginUserId || "-"
      },
      {
        name: "Login User Email ID:",
        value: data?.notificationDetail?.userNotification?.loginUserEmail || "-"
      },
      {
        name: "Dealer Number:",
        value: data?.notificationDetail?.userNotification?.dealerNumber || "-"
      }
    ]);
    //eslint-disable-next-line
  }, [data, componentType]);

  return (
    <div className="flex flex-col gap-6">
      <div className="size-full rounded-[10px] bg-white px-5 py-6">
        <div className="flex justify-between">
          <span className="font-InterSemiBold text-ft15-18 text-black-10">
            Claim Number
          </span>
        </div>
        <div className="flex gap-3">
          <span className="font-InterMedium text-ft25-30 text-black-10">
            {data?.claimNumber}
          </span>
          <span
            className={`flex h-6 items-center rounded-[5px] ${data?.contractAgent?.agentCode === "001500" ? "bg-red-10 text-white" : "bg-darkGrey-20 text-darkGrey-10"} px-2 font-InterRegular text-ft14-17 `}
          >
            Program Name: {data?.contractAgent?.agentName}
          </span>
          <span
            className={`flex h-6 items-center rounded-[5px] ${data?.contractAgent?.agentCode === "001500" ? "bg-red-10 text-white" : "bg-darkGrey-20 text-darkGrey-10"} px-2 font-InterRegular text-ft14-17`}
          >
            Program Code: {data?.contractAgent?.agentCode}
          </span>
        </div>
        <div className="pt-3">
          <span className="font-InterSemiBold text-ft15-18 text-black-10">
            Contract Details
          </span>
        </div>
        <div className="flex w-80per flex-wrap justify-between gap-y-2.5 pt-2.5">
          {values.map((item, idx) => (
            <div key={idx} className="flex w-1/2 justify-between">
              <span className="w-1/2 font-InterRegular text-ft15-18 text-grey-50">
                {item.name}
              </span>
              <span className="w-1/2 font-InterMedium text-ft15-18 text-black-10">
                {item.value}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="size-full rounded-[10px] bg-white px-5 py-3">
        <div className="pt-3">
          <span className="font-InterSemiBold text-ft15-18 text-black-10">
            Processing Details
          </span>
        </div>

        <div className="flex w-full flex-wrap gap-y-2.5 pt-2.5">
          {processingValue.map((item, idx) => (
            <div key={idx} className="flex w-1/2 gap-2">
              <span className="w-2/3 font-InterRegular text-ft15-18 text-grey-50">
                {item.name}
              </span>
              <span className="w-2/3 font-InterMedium text-ft15-18 text-black-10">
                {item.value}
              </span>
            </div>
          ))}
        </div>
        <div className="flex gap-3">
          <div className="flex w-1/2 flex-col gap-2">
            <div className="flex flex-col gap-3 pt-3">
              <span className="font-InterSemiBold text-ft15-18 text-black-10">
                Notification Details
              </span>
            </div>
            <div className="flex size-full flex-col gap-3 rounded-md bg-grey-110 p-4">
              {notification.map((item, idx) => {
                if (!item.value) return;
                return (
                  <div key={idx} className="flex w-full justify-between">
                    <div className="flex w-1/2 flex-col">
                      <span className="font-InterRegular text-ft15-18 text-grey-50">
                        {item.name}
                      </span>
                      {item.label && (
                        <span className="font-InterRegular text-ft15-18 text-grey-50">
                          {item.label}
                        </span>
                      )}
                    </div>
                    <span className="w-1/2 font-InterMedium text-ft15-18 text-black-10">
                      {item.value}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="flex w-1/2 flex-col gap-2">
            <div className="pt-3">
              <span className="font-InterSemiBold text-ft15-18 text-black-10">
                User Details
              </span>
            </div>
            <div className="flex size-full flex-col gap-3 rounded-md bg-grey-110 p-4">
              {user.map((item, idx) => (
                <div key={idx} className="flex w-full gap-3">
                  <span className="w-1/2 font-InterRegular text-ft15-18 text-grey-50">
                    {item.name}
                  </span>
                  <span className="w-1/2 font-InterMedium text-ft15-18 text-black-10">
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="flex flex-col gap-2">
        <div
          onClick={() => setIsSLAShow(!isSLAShow)}
          className="flex gap-4 size-full rounded-[10px] bg-white px-3 py-3 cursor-pointer"
        >
          {isSLAShow ? <IoIosArrowDown /> : <IoIosArrowForward />}
          <span className="font-InterSemiBold text-ft15-18 text-black-10">
            Claim Processing Details
          </span>
        </div>
        {isSLAShow && (
          <SLAInfo claimProcessingDetails={data?.claimProcessingDetails} />
        )}
      </div> */}
      <ComparisonList
        imagesData={imagesData}
        setImagePopup={setImagePopup}
        openReasonPopup={openReasonPopup}
        handleFeedback={handleFeedback}
        handleUpdateFeedback={handleUpdateFeedback}
        setOpenReasonPopup={setOpenReasonPopup}
        data={data}
        setQuestions={setQuestions}
        allImages={allImages}
        questions={questions}
        setComponentType={setComponentType}
        componentType={componentType}
        localFeedbackData={feedbackData}
        setComponentFeedback={setComponentFeedback}
        componentFeedback={componentFeedback}
        setCheckFeedback={setCheckFeedback}
        checkFeedback={checkFeedback}
      />
    </div>
  );
};

export default ClaimDetails;
